// Comprehensive Events Database - Northeast Automotive Events
// Last updated: February 2026 - Verified links and comprehensive coverage

export const EVENT_TYPES = [
  { id: 'all', label: 'All Events' },
  { id: 'show', label: 'Car Shows & Concours' },
  { id: 'drive', label: 'Drives & Tours' },
  { id: 'track', label: 'Track Days' },
  { id: 'auction', label: 'Auctions' },
  { id: 'meetup', label: 'Meetups & Cars & Coffee' },
  { id: 'rally', label: 'Rallies' },
  { id: 'workshop', label: 'Workshops & Tech' },
  { id: 'vintage', label: 'Vintage Racing' }
]

// Comprehensive events data with verified links
export const SAMPLE_EVENTS = [
  // ============================================
  // MAJOR CONCOURS & SHOWS
  // ============================================
  {
    id: '1',
    title: 'Greenwich Concours d\'Elegance',
    type: 'show',
    date: '2026-05-30',
    endDate: '2026-06-01',
    time: '10:00 AM - 4:00 PM',
    location: 'Roger Sherman Baldwin Park, Greenwich, CT',
    description: 'One of the premier automotive events on the East Coast, featuring hundreds of rare and significant automobiles in a stunning waterfront setting.',
    organizer: 'Greenwich Concours d\'Elegance Foundation',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&auto=format&fit=crop',
    link: 'https://www.greenwichconcours.com/',
    featured: true,
    rsvpCount: 2500,
    cost: '$30-$150',
    tags: ['Concours', 'Vintage', 'Charity', 'Premier']
  },
  {
    id: '2',
    title: 'Audrain Newport Concours & Motor Week',
    type: 'show',
    date: '2026-10-01',
    endDate: '2026-10-04',
    time: 'Various',
    location: 'The Breakers, Newport, RI',
    description: 'International Motoring Event of the Year 2025. Four days of automotive celebration including 50-Mile Supercar Drive, seminars, gala, and Concours at The Breakers.',
    organizer: 'Audrain Automobile Museum',
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=600&auto=format&fit=crop',
    link: 'https://www.audrainconcours.com/',
    featured: true,
    rsvpCount: 1800,
    cost: 'Various tiers',
    tags: ['Concours', 'Motor Week', 'World Class', 'Auctions']
  },
  {
    id: '3',
    title: 'Radnor Hunt Concours d\'Elegance',
    type: 'show',
    date: '2026-09-11',
    endDate: '2026-09-13',
    time: '10:00 AM',
    location: 'Radnor Hunt, Malvern, PA',
    description: 'Only US concours featuring coaches and carriages alongside classic automobiles. 29th Annual event blending automotive and equestrian heritage.',
    organizer: 'Radnor Hunt Concours',
    link: 'https://radnorconcours.org/',
    featured: true,
    rsvpCount: 800,
    cost: '$40-$200',
    tags: ['Concours', 'Equestrian', 'Vintage', 'Unique']
  },
  {
    id: '4',
    title: 'Great Marques Concours d\'Elegance',
    type: 'show',
    date: '2026-09-28',
    time: '9:00 AM - 3:00 PM',
    location: 'Morgan Memorial Park, Glen Cove, Long Island, NY',
    description: 'Long Island\'s premier car club concours featuring Ferrari Club, MBCA, BMW CCA, and more. Accessible judging and friendly atmosphere.',
    organizer: 'Great Marques',
    link: 'https://greatmarques.org/',
    featured: false,
    rsvpCount: 350,
    cost: '$25-$50',
    tags: ['Concours', 'Club', 'Long Island']
  },

  // ============================================
  // CARS & COFFEE / MEETUPS
  // ============================================
  {
    id: '5',
    title: 'Caffeine & Carburetors',
    type: 'meetup',
    date: '2026-03-15',
    time: '8:00 AM - 11:00 AM',
    location: 'Zumbach\'s Gourmet Coffee, New Canaan, CT',
    description: 'New Canaan\'s premier gathering for unique and rare cars. No jury, all welcome, free admission. Some of the most interesting cars in the Northeast.',
    organizer: 'Caffeine & Carburetors',
    link: 'https://caffeineandcarburetors.com/',
    featured: true,
    rsvpCount: 500,
    cost: 'Free',
    tags: ['Cars & Coffee', 'Casual', 'All Makes', 'Weekly']
  },
  {
    id: '6',
    title: 'Cars and Coffee Darien',
    type: 'meetup',
    date: '2026-04-12',
    time: '8:00 AM - 11:00 AM',
    location: 'Old Mill Center, Darien, CT',
    description: 'Second Sunday of the month, April-November. Family-friendly with monthly manufacturer features. Coffee and breakfast available.',
    organizer: 'Cars and Coffee Darien',
    link: 'https://carsandcoffeedarien.com/',
    featured: false,
    rsvpCount: 200,
    cost: 'Free',
    tags: ['Cars & Coffee', 'Family Friendly', 'Monthly']
  },
  {
    id: '7',
    title: 'Audrain Cars & Coffee',
    type: 'meetup',
    date: '2026-05-03',
    time: '8:00 AM - 11:00 AM',
    location: 'Audrain Auto Museum, Newport, RI',
    description: 'Monthly gatherings at the prestigious Audrain Auto Museum. 350-400 cars typical. Members register Monday before, public Wednesday before.',
    organizer: 'Audrain Auto Museum',
    link: 'https://www.audrainautomuseum.org/cars-and-coffee-2025',
    featured: true,
    rsvpCount: 400,
    cost: 'Free-$10',
    tags: ['Cars & Coffee', 'Museum', 'Premium']
  },
  {
    id: '8',
    title: 'Bedford Cars & Coffee Season Opener',
    type: 'meetup',
    date: '2026-05-04',
    time: '9:00 AM',
    location: 'Craft Food Halls - 5 Wayside Rd, Burlington, MA',
    description: 'Season opener for the Bedford MA Cars & Coffee community. Family-friendly, all makes welcome.',
    organizer: 'Bedford MA Cars',
    link: 'https://www.bedfordmacars.com/events',
    featured: false,
    rsvpCount: 150,
    cost: 'Free',
    tags: ['Cars & Coffee', 'Season Opener', 'Massachusetts']
  },
  {
    id: '9',
    title: 'Westchester Cars & Coffee',
    type: 'meetup',
    date: '2026-04-05',
    time: '8:00 AM - 11:00 AM',
    location: 'Peekskill, NY',
    description: 'Running since 2012, welcoming all cars from gearheads to novices. Diversity welcome.',
    organizer: 'Westchester Cars & Coffee',
    link: 'https://westchestercarsandcoffee.com/',
    featured: false,
    rsvpCount: 175,
    cost: 'Free',
    tags: ['Cars & Coffee', 'Inclusive', 'Westchester']
  },

  // ============================================
  // TRACK DAYS & HPDE
  // ============================================
  {
    id: '10',
    title: 'SCDA Track Day - Lime Rock Park',
    type: 'track',
    date: '2026-03-21',
    time: '7:00 AM - 5:00 PM',
    location: 'Lime Rock Park, Lakeville, CT',
    description: 'Strictly educational, non-competitive track day. Excellent novice program with professional instruction included for first-timers.',
    organizer: 'Sports Car Driving Association',
    link: 'https://scda1.com/',
    featured: true,
    rsvpCount: 60,
    cost: '$399-$599',
    tags: ['Track Day', 'HPDE', 'Novice Friendly', 'Instruction']
  },
  {
    id: '11',
    title: 'NASA Northeast - Watkins Glen',
    type: 'track',
    date: '2026-05-15',
    endDate: '2026-05-17',
    time: 'All Day',
    location: 'Watkins Glen International, Watkins Glen, NY',
    description: 'HPDE and competition events at the legendary Watkins Glen. Multiple run groups from novice to advanced.',
    organizer: 'NASA Northeast',
    link: 'https://nasane.com/',
    featured: true,
    rsvpCount: 120,
    cost: '$200-$500',
    tags: ['HPDE', 'Racing', 'Watkins Glen']
  },
  {
    id: '12',
    title: 'NASA Northeast - NJMP Thunderbolt',
    type: 'track',
    date: '2026-03-14',
    endDate: '2026-03-15',
    time: 'All Day',
    location: 'New Jersey Motorsports Park, Millville, NJ',
    description: 'HPDE weekend at NJMP Thunderbolt course. Competition school and time trials available.',
    organizer: 'NASA Northeast',
    link: 'https://nasane.com/',
    featured: false,
    rsvpCount: 85,
    cost: '$200-$400',
    tags: ['HPDE', 'NJMP', 'Time Trials']
  },
  {
    id: '13',
    title: 'SCDA Track Day - Palmer Motorsports Park',
    type: 'track',
    date: '2026-05-22',
    time: '7:00 AM',
    location: 'Palmer Motorsports Park, Palmer, MA',
    description: '2.3-mile twisty track with 190 feet elevation change. First true road course in Massachusetts.',
    organizer: 'Sports Car Driving Association',
    link: 'https://scda1.com/',
    featured: false,
    rsvpCount: 45,
    cost: '$399-$599',
    tags: ['Track Day', 'Palmer', 'Twisty']
  },
  {
    id: '14',
    title: 'Porsche on the Mountain',
    type: 'track',
    date: '2026-10-04',
    time: '9:00 AM - 4:00 PM',
    location: 'Palmer Motorsports Park, Palmer, MA',
    description: '50+ vendor spots, swap meet, track exhibitions, Hot Lap rides ($150 donation benefits Homes for Our Troops). Awards in 14 categories.',
    organizer: 'Porsche on the Mountain',
    link: 'https://porscheonthemountain.com/',
    featured: true,
    rsvpCount: 300,
    cost: 'Free-$150',
    tags: ['Porsche', 'Charity', 'Hot Laps', 'Show']
  },

  // ============================================
  // VINTAGE RACING
  // ============================================
  {
    id: '15',
    title: 'Lime Rock Historic Festival 44',
    type: 'vintage',
    date: '2026-09-03',
    endDate: '2026-09-07',
    time: 'All Day',
    location: 'Lime Rock Park, Lakeville, CT',
    description: 'Three days of vintage racing action featuring historic race cars from all eras. 17-mile vintage race car parade kicks off Labor Day weekend.',
    organizer: 'Lime Rock Park',
    image: 'https://images.unsplash.com/photo-1558981403-c5f9899a28bc?w=600&auto=format&fit=crop',
    link: 'https://limerock.com/events/historic-festival/',
    featured: true,
    rsvpCount: 5000,
    cost: '$40-$200',
    tags: ['Vintage Racing', 'Historic', 'Lime Rock', 'Labor Day']
  },
  {
    id: '16',
    title: 'Watkins Glen SpeedTour',
    type: 'vintage',
    date: '2026-09-10',
    endDate: '2026-09-13',
    time: 'All Day',
    location: 'Watkins Glen International, Watkins Glen, NY',
    description: 'SVRA vintage racing featuring classic Corvettes, Alfas, Porsches, Historic F1 & Indy cars. Grand Prix Festival Friday includes downtown reenactment.',
    organizer: 'SVRA',
    link: 'https://svra.com/',
    featured: true,
    rsvpCount: 20000,
    cost: '$35-$150',
    tags: ['Vintage Racing', 'Grand Prix Festival', 'SVRA', 'Camaro/Firebird']
  },
  {
    id: '17',
    title: 'Trans Am Memorial Day Classic',
    type: 'vintage',
    date: '2026-05-22',
    endDate: '2026-05-25',
    time: 'All Day',
    location: 'Lime Rock Park, Lakeville, CT',
    description: 'Memorial Day weekend of Trans Am racing action at Lime Rock Park.',
    organizer: 'Lime Rock Park',
    link: 'https://limerock.com/',
    featured: false,
    rsvpCount: 3000,
    cost: '$30-$100',
    tags: ['Trans Am', 'Racing', 'Memorial Day']
  },

  // ============================================
  // AUCTIONS
  // ============================================
  {
    id: '18',
    title: 'Amelia Island - Broad Arrow Auctions',
    type: 'auction',
    date: '2026-03-06',
    endDate: '2026-03-07',
    time: '5:00 PM',
    location: 'The Ritz-Carlton, Amelia Island, FL',
    description: '~150 cars from pre-war to modern. Bill Spurling Collection includes 1935 Duesenberg. Wellington Morton Collection features 1954 Mercedes 300 SL.',
    organizer: 'Broad Arrow Auctions',
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=600&auto=format&fit=crop',
    link: 'https://www.broadarrowauctiongroup.com/',
    featured: true,
    rsvpCount: 500,
    cost: 'Bidder registration required',
    tags: ['Auction', 'High-End', 'Amelia Island', 'Collectors']
  },
  {
    id: '19',
    title: 'Amelia Island - Gooding Christie\'s',
    type: 'auction',
    date: '2026-03-05',
    endDate: '2026-03-06',
    time: '5:00 PM',
    location: 'The Ritz-Carlton, Amelia Island, FL',
    description: 'Curated collector cars auction during Amelia Concours week.',
    organizer: 'Gooding & Company / Christie\'s',
    link: 'https://www.goodingco.com/',
    featured: false,
    rsvpCount: 400,
    cost: 'Bidder registration required',
    tags: ['Auction', 'Curated', 'Amelia Island']
  },
  {
    id: '20',
    title: 'Audrain Newport Auction',
    type: 'auction',
    date: '2026-10-02',
    time: '5:00 PM',
    location: 'Audrain Auto Museum, Newport, RI',
    description: 'Bonhams auction during Audrain Motor Week. Multi-year strategic partnership announced.',
    organizer: 'Bonhams',
    link: 'https://www.bonhams.com/',
    featured: false,
    rsvpCount: 200,
    cost: 'Bidder registration required',
    tags: ['Auction', 'Newport', 'Bonhams']
  },

  // ============================================
  // RALLY EVENTS
  // ============================================
  {
    id: '21',
    title: 'Rally North America - Spring Rally',
    type: 'rally',
    date: '2026-05-08',
    endDate: '2026-05-10',
    time: 'Various',
    location: 'Northeast (route TBA)',
    description: 'Charity rally tours supporting Hope for the Warriors, Concerns of Police Survivors, Camp Sunshine. Automotive scavenger hunt format.',
    organizer: 'Rally North America',
    link: 'https://rallynorthamerica.com/',
    featured: true,
    rsvpCount: 75,
    cost: '$2,500+',
    tags: ['Rally', 'Charity', 'Adventure', 'Luxury']
  },
  {
    id: '22',
    title: 'New England Region SCCA Rally',
    type: 'rally',
    date: '2026-06-14',
    time: '8:00 AM',
    location: 'TBA, New England',
    description: 'GTA (Game-Tour-Adventure) road rally with map-based navigation. Answer questions while minimizing distance.',
    organizer: 'New England Region SCCA',
    link: 'https://ner.org/',
    featured: false,
    rsvpCount: 30,
    cost: '$50-$85',
    tags: ['Rally', 'Navigation', 'SCCA']
  },

  // ============================================
  // AUTOCROSS
  // ============================================
  {
    id: '23',
    title: 'PCA Northeast Region Autocross #1',
    type: 'track',
    date: '2026-04-19',
    time: '7:00 AM',
    location: 'Moore Airfield, Devens, MA',
    description: 'Timed competition on a cone course. Great way to explore your car\'s limits safely. Eight car clubs rotate use of this facility.',
    organizer: 'PCA Northeast Region',
    link: 'https://porschenet.com/',
    featured: false,
    rsvpCount: 80,
    cost: '$60-$75',
    tags: ['Autocross', 'Porsche', 'Competition']
  },
  {
    id: '24',
    title: 'NNJR SCCA Autocross - MetLife Stadium',
    type: 'track',
    date: '2026-04-12',
    time: '8:00 AM',
    location: 'MetLife Stadium, East Rutherford, NJ',
    description: 'Year-round autocross at MetLife Stadium parking lots. Weekend memberships available.',
    organizer: 'NNJR SCCA',
    link: 'https://scca-nnjr.com/',
    featured: false,
    rsvpCount: 60,
    cost: '$50-$65',
    tags: ['Autocross', 'SCCA', 'MetLife']
  },

  // ============================================
  // CLUB EVENTS
  // ============================================
  {
    id: '25',
    title: 'PCA Northeast Region Concours at The Elms',
    type: 'show',
    date: '2026-10-04',
    time: '10:00 AM',
    location: 'The Elms Mansion, Newport, RI',
    description: 'PCA-sanctioned concours during Audrain Motor Week at the historic Elms mansion.',
    organizer: 'PCA Northeast Region',
    link: 'https://porschenet.com/',
    featured: false,
    rsvpCount: 75,
    cost: '$50',
    tags: ['Concours', 'Porsche', 'Newport']
  },
  {
    id: '26',
    title: 'BMW CCA Boston Concours d\'Elegance',
    type: 'show',
    date: '2026-07-26',
    time: '10:00 AM',
    location: 'Boston area (TBA)',
    description: 'Annual BMW CCA Boston Chapter concours d\'elegance.',
    organizer: 'BMW CCA Boston',
    link: 'https://boston-bmwcca.org/',
    featured: false,
    rsvpCount: 80,
    cost: '$25-$40',
    tags: ['Concours', 'BMW', 'Boston']
  },
  {
    id: '27',
    title: 'PCA NNJR New Member Gathering',
    type: 'meetup',
    date: '2026-10-10',
    time: '12:00 PM - 2:00 PM',
    location: 'Porsche Edison, Edison, NJ',
    description: 'Welcome gathering for new PCA members. Lunch provided.',
    organizer: 'PCA Northern New Jersey Region',
    link: 'https://nnjr-pca.com/',
    featured: false,
    rsvpCount: 35,
    cost: 'Free (members)',
    tags: ['Social', 'Porsche', 'New Members']
  },

  // ============================================
  // SPECIAL SHOWS
  // ============================================
  {
    id: '28',
    title: 'British Invasion',
    type: 'show',
    date: '2026-09-18',
    endDate: '2026-09-20',
    time: '9:00 AM',
    location: 'Stowe, VT',
    description: 'One of the largest British car shows in North America. Over 600 vehicles expected across marques from Aston Martin to TVR.',
    organizer: 'British Invasion Inc.',
    image: 'https://images.unsplash.com/photo-1617469767053-d3b523a0b982?w=600&auto=format&fit=crop',
    link: 'https://www.britishinvasion.com/',
    featured: true,
    rsvpCount: 600,
    cost: '$15-$25',
    tags: ['British Cars', 'Show', 'Stowe', 'Vermont']
  },
  {
    id: '29',
    title: 'Vermont Antique & Classic Car Meet',
    type: 'show',
    date: '2026-08-07',
    endDate: '2026-08-09',
    time: '9:00 AM',
    location: 'Farr\'s Field, Waterbury, VT',
    description: 'Brass-Era vehicles, vintage Mustangs, military rigs, tractors, exotics. Vermont\'s premier antique car meet.',
    organizer: 'VAE',
    featured: false,
    rsvpCount: 400,
    cost: '$15-$20',
    tags: ['Antique', 'Classic', 'Vermont']
  },
  {
    id: '30',
    title: 'MiataCon at Lime Rock',
    type: 'track',
    date: '2026-10-23',
    endDate: '2026-10-24',
    time: 'All Day',
    location: 'Lime Rock Park, Lakeville, CT',
    description: 'Annual Miata enthusiast gathering with track time at Lime Rock Park.',
    organizer: 'MiataCon',
    link: 'https://limerock.com/',
    featured: false,
    rsvpCount: 200,
    cost: '$200-$400',
    tags: ['Miata', 'Track Day', 'Enthusiast']
  },

  // ============================================
  // CHARITY EVENTS
  // ============================================
  {
    id: '31',
    title: 'Dream Show Car Edition',
    type: 'show',
    date: '2026-08-08',
    time: '10:00 AM',
    location: 'Farmington Polo Club, CT',
    description: 'Largest car show benefiting The Hometown Foundation. Classics, muscle, custom builds from hundreds of international participants.',
    organizer: 'Dream Ride Weekend',
    link: 'https://dreamride.org/',
    featured: true,
    rsvpCount: 500,
    cost: '$20-$50',
    tags: ['Charity', 'Show', 'Family', 'Hometown Foundation']
  },
  {
    id: '32',
    title: 'KIDSAFE CT Car Show',
    type: 'show',
    date: '2026-06-06',
    time: '10:00 AM - 3:00 PM',
    location: 'Connecticut (TBA)',
    description: '14th Annual family-friendly car show supporting child safety.',
    organizer: 'KIDSAFE CT',
    link: 'https://thevillage.org/',
    featured: false,
    rsvpCount: 200,
    cost: '$10-$25',
    tags: ['Charity', 'Family', 'KIDSAFE']
  },
  {
    id: '33',
    title: 'Good Times Motoring Club Cruise',
    type: 'drive',
    date: '2026-04-15',
    time: '5:00 PM',
    location: 'Connecticut (TBA)',
    description: 'Third Wednesday of each month, April-September. Supports Harlows Heroes (K9 unit charity) and local charities.',
    organizer: 'Good Times Motoring Club',
    link: 'https://www.goodtimesmotoringclub.com/',
    featured: false,
    rsvpCount: 50,
    cost: 'Free',
    tags: ['Cruise', 'Charity', 'Monthly']
  },

  // ============================================
  // TECH SESSIONS & WORKSHOPS
  // ============================================
  {
    id: '34',
    title: 'PCA Driver Education Ground School',
    type: 'workshop',
    date: '2026-03-08',
    time: '9:00 AM - 12:00 PM',
    location: 'TBA, Massachusetts',
    description: 'Introduction to track days. Covers safety, car prep, track etiquette, and what to expect.',
    organizer: 'PCA Northeast Region',
    link: 'https://porschenet.com/',
    featured: false,
    rsvpCount: 40,
    cost: 'Free',
    tags: ['Workshop', 'Track Prep', 'Educational']
  },
  {
    id: '35',
    title: 'Audi Club NEQ Winter Driving School',
    type: 'workshop',
    date: '2026-01-24',
    time: '8:00 AM',
    location: 'TBA (ice/snow venue)',
    description: 'Learn to control your quattro on ice and snow. Professional instruction in a safe environment.',
    organizer: 'Audi Club Northeast Quattro',
    link: 'https://www.neqclub.org/',
    featured: false,
    rsvpCount: 25,
    cost: '$300-$500',
    tags: ['Winter Driving', 'Quattro', 'Skills']
  },

  // ============================================
  // SPECIAL TRACK EVENTS
  // ============================================
  {
    id: '36',
    title: 'NASCAR Craftsman Truck Series at Lime Rock',
    type: 'track',
    date: '2026-07-10',
    endDate: '2026-07-11',
    time: 'All Day',
    location: 'Lime Rock Park, Lakeville, CT',
    description: 'NASCAR Craftsman Truck Series and ARCA Menards Series races at Lime Rock Park.',
    organizer: 'Lime Rock Park',
    link: 'https://limerock.com/',
    featured: true,
    rsvpCount: 15000,
    cost: '$40-$150',
    tags: ['NASCAR', 'Trucks', 'ARCA']
  },
  {
    id: '37',
    title: 'GRIDLIFE Circuit Legends at Lime Rock',
    type: 'track',
    date: '2026-08-14',
    endDate: '2026-08-16',
    time: 'All Day',
    location: 'Lime Rock Park, Lakeville, CT',
    description: 'GRIDLIFE festival combining time attack, drifting, and music at Lime Rock Park.',
    organizer: 'GRIDLIFE',
    link: 'https://limerock.com/',
    featured: false,
    rsvpCount: 3000,
    cost: '$50-$200',
    tags: ['GRIDLIFE', 'Time Attack', 'Festival']
  },

  // ============================================
  // RECURRING CRUISE NIGHTS
  // ============================================
  {
    id: '38',
    title: 'Patriot Place Cruise Nights',
    type: 'meetup',
    date: '2026-04-22',
    time: '5:00 PM - 8:00 PM',
    location: 'Bass Pro Shops, Patriot Place, Foxborough, MA',
    description: 'Bi-weekly April-October cruise nights organized by Mass Cruisers Auto Club. Free, family-friendly.',
    organizer: 'Mass Cruisers Auto Club',
    featured: false,
    rsvpCount: 300,
    cost: 'Free',
    tags: ['Cruise Night', 'Family', 'Bi-weekly']
  },

  // ============================================
  // AMELIA CONCOURS (Regional Importance)
  // ============================================
  {
    id: '39',
    title: 'The Amelia Concours d\'Elegance',
    type: 'show',
    date: '2026-03-05',
    endDate: '2026-03-08',
    time: 'Various',
    location: 'The Ritz-Carlton, Amelia Island, FL',
    description: '250 vehicles across 30 classes. Includes RADwood 80s/90s event, Cars & Community. A pilgrimage for Northeast collectors.',
    organizer: 'The Amelia',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&auto=format&fit=crop',
    link: 'https://www.ameliaconcours.com/',
    featured: true,
    rsvpCount: 10000,
    cost: '$75-$500',
    tags: ['Concours', 'Amelia Island', 'Premier', 'RADwood']
  }
]

// Helper functions
export function getUpcomingEvents(limit = 10) {
  const today = new Date().toISOString().split('T')[0]
  return SAMPLE_EVENTS
    .filter(event => event.date >= today)
    .sort((a, b) => new Date(a.date) - new Date(b.date))
    .slice(0, limit)
}

export function getFeaturedEvents() {
  return SAMPLE_EVENTS.filter(event => event.featured)
}

export function getEventsByType(type) {
  if (type === 'all') return SAMPLE_EVENTS
  return SAMPLE_EVENTS.filter(event => event.type === type)
}

export function searchEvents(query) {
  const q = query.toLowerCase()
  return SAMPLE_EVENTS.filter(event =>
    event.title.toLowerCase().includes(q) ||
    event.description.toLowerCase().includes(q) ||
    event.location.toLowerCase().includes(q) ||
    event.tags?.some(tag => tag.toLowerCase().includes(q))
  )
}

export function formatEventDate(dateStr, endDateStr = null) {
  const date = new Date(dateStr + 'T00:00:00')
  const options = { weekday: 'short', month: 'short', day: 'numeric' }

  if (endDateStr && endDateStr !== dateStr) {
    const endDate = new Date(endDateStr + 'T00:00:00')
    return `${date.toLocaleDateString('en-US', options)} - ${endDate.toLocaleDateString('en-US', options)}`
  }

  return date.toLocaleDateString('en-US', { ...options, year: 'numeric' })
}
